import * as React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import Footer from '../../components/footer/Footer';
import HeaderLoggedOut from '../../components/headerLoggedOut/HeaderLoggedOut';
import './ForgotPasswordResult.css';

export default class ForgotPasswordResult extends React.PureComponent {
    public render() {
        return (
            <>
                <HeaderLoggedOut />
                <Container id="registrationResultView" className="text-center">
                    <Row>
                        <Col>
                            <h3>{TR.forgotPasswordResult_sent}</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="offset-md-3">
                            {TR.forgotPasswordResult_new_password_help}
                            <br />
                            <Link to="/" className="btn mt-4">
                                {TR.forgotPasswordResult_back_to_login}
                            </Link>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/forgotPasswordResult/ForgotPasswordResult.tsx